export const PARTICULARS_HEADINGS = [
  {
    name: "Type",
    width: "120px",
  },
  {
    name: "Service Description",
    width: "260px",
  },
  {
    name: "HSN / SAC",
    width: "auto",
  },
  {
    name: "Units",
    width: "auto",
  },
  {
    name: "Rate",
    width: "auto",
  },
  {
    name: "Discount",
    width: "auto",
  },
  {
    name: "Amount",
    width: "auto",
  },
  {
    name: "IGST",
    width: "200px",
  },
  {
    name: "Action",
    width: "80px",
  },
];
